import html from "./InstructionStep.html"

var module = angular.module("ResearchKitApplicationModule");

module.directive("instructionStep", ['ceUrl',
	function (ceUrl) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			}
		};
	}]
);

module.factory("InstructionStepManager", ["StepManager", function (StepManager) {

	function InstructionStepManager(step, surveyManager) {
		StepManager.call(this, step, surveyManager);
	}
	InstructionStepManager.prototype = Object.create(StepManager.prototype);

	InstructionStepManager.prototype.isLastInstructionStep = function () {
		if (this.surveyManager.editMode) {
			return false;
		}

		for (var i = 0; i < this.surveyManager.managedStepIdentifiers.length; i++) {
			var identifier = this.surveyManager.managedStepIdentifiers[i];
			var step = _.findWhere(this.surveyManager.template.steps, { identifier: identifier });
			if (step.type != 'InstructionStep') {
				return false;
			}
		}

		var nextStep = this.surveyManager.nextStep();
		if (nextStep && nextStep.type != 'InstructionStep') {
			return true;
		}
		return false;
	}

	return InstructionStepManager;
}]);